/**
 *
 * @export
 * @interface Resource
 */
export interface Resource {
  /**
   *
   * @type {string}
   * @memberof Resource
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof Resource
   */
  url: string
}

/**
 * Check if a given object implements the Resource interface.
 */
export function instanceOfResource(value: object): boolean {
  if (!('name' in value)) {return false}
  if (!('url' in value)) {return false}
  return true
}

export function ResourceFromJSON(json: any): Resource {
  return ResourceFromJSONTyped(json, false)
}

export function ResourceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Resource {
  if (json == null) {
    return json
  }
  return {
    name: json.name,
    url: json.url
  }
}

export function ResourceToJSON(value?: Resource | null): any {
  if (value == null) {
    return value
  }
  return {
    name: value.name,
    url: value.url
  }
}
